import { forwardRef } from 'react';
import { StyledCounterBadge, SelectTriggerWrapper } from './MultiSelectDropdown.styles';

export const MULTI_SELECT_TRIGGER_TEST_ID = 'multi-select-trigger-test-id';

// interface MultiSelectTriggerProps {
//   /** The selected values */
//   values?: string[];
//   /**
//    * The name of the field
//    * Determines the text after "Select"/"Selected"
//    */
//   fieldName?: string;
//   /** The ref of the component */
//   ref?: Ref;
// }

export const MultiSelectTrigger = forwardRef(function MultiSelectTrigger(
  { values = [], fieldName } /* : MultiSelectTriggerProps */,
  ref,
) {
  const isSet = !!values.length;
  return (
    <SelectTriggerWrapper
      data-test={MULTI_SELECT_TRIGGER_TEST_ID}
      ref={ref}
      isSet={isSet}
      className={isSet ? '' : 'default text'}
    >
      {isSet ? (
        <>
          Selected {`${fieldName} ` || ' '}
          <StyledCounterBadge>{values.length}</StyledCounterBadge>
        </>
      ) : (
        <>Select{fieldName ? ` ${fieldName}` : ''}...</>
      )}
    </SelectTriggerWrapper>
  );
});
